const basePath = '/financial/invoicesIssuedForCnpj'

export const apiSync = (): string => `${basePath}/sync`

export const apiDownloadXml = (id: number): string =>
  `${basePath}/xml/download/${id}`

export const apiDownloadPdf = (id: number): string =>
  `${basePath}/pdf/download/${id}`

export const apiDownloadXmlBatch = (query: string): string =>
  `${basePath}/xml/download/batch?${query}`

export const apiDownloadPdfBatch = (query: string): string =>
  `${basePath}/pdf/download/batch?${query}`
